import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { dashboardService } from '../../services/api';

const AppointmentStatusChart = () => {
    const [statusData, setStatusData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadAppointmentStatus();
    }, []);

    const loadAppointmentStatus = async () => {
        try {
            setLoading(true);
            const response = await dashboardService.getAppointmentStatus();
            if (response.success && response.data) {
                setStatusData(response.data);
            }
        } catch (error) {
            console.error('Error loading appointment status:', error);
        } finally {
            setLoading(false);
        }
    };

    const total = statusData.reduce((sum, item) => sum + (item.count || 0), 0);

    const chartOptions = {
        chart: {
            type: 'bar',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '60%',
                dataLabels: {
                    position: 'top'
                }
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                const count = val; // val is the actual value
                const percent = total > 0 ? ((count / total) * 100).toFixed(1) : '0.0';
                return count + ' (' + percent + '%)';
            },
            offsetY: -20,
            style: {
                fontSize: '12px',
                colors: ['#fff'],
                fontWeight: 'bold'
            }
        },
        xaxis: {
            categories: statusData.map(item => item.name || item.status || 'Bilinmeyen'),
            labels: {
                style: {
                    colors: '#6b7280',
                    fontSize: '12px'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#6b7280',
                    fontSize: '12px'
                },
                formatter: function (val) {
                    return Math.floor(val);
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val, opts) {
                    const percent = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                    return val + ' adet (' + percent + '%)';
                }
            }
        },
        colors: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#64748b', '#a855f7'],
        legend: {
            show: false
        }
    };

    const chartSeries = [{
        name: 'Randevu Sayısı',
        data: statusData.map(item => item.count || 0)
    }];

    return (
        <div className="col-xxl-6 col-xl-12">
            <div className="card h-100">
                <div className="card-body">
                    <div className="d-flex flex-wrap align-items-center justify-content-between mb-16">
                        <h6 className="text-lg mb-0">Randevu Durumları</h6>
                    </div>
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                            <p className="text-secondary-light">Yükleniyor...</p>
                        </div>
                    ) : statusData.length > 0 ? (
                        <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={300} />
                    ) : (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                            <p className="text-secondary-light">Veri bulunamadı</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppointmentStatusChart;

